import type { PreviewUploadsController } from '../../../hooks/useDappFileHandlers';
import * as Form from '../../Form';
import { BasicDetailsSectionBase } from '../../dapp-form/sections/BasicDetailsSectionBase';
import { PreviewUploadsField } from '../components/PreviewUploadsField';
import { PackageNameField } from '../components/PackageNameField';
import { WalletField } from '../components/WalletField';
import type {
  FormState,
  NewDappInputChangeEvent,
  SingleFileFieldName,
} from '../types';

interface BasicDetailsSectionProps {
  formData: FormState;
  previewUploads: PreviewUploadsController;
  packageNameError: string | null;
  isCheckingPackageName: boolean;
  showPackageNameSpinner: boolean;
  packageNameValid: boolean;
  onInputChange: (event: NewDappInputChangeEvent) => void;
  onSingleFileChange: (
    fieldName: SingleFileFieldName,
    file: File | null,
  ) => void;
}

export function BasicDetailsSection({
  formData,
  previewUploads,
  packageNameError,
  isCheckingPackageName,
  showPackageNameSpinner,
  packageNameValid,
  onInputChange,
  onSingleFileChange,
}: BasicDetailsSectionProps) {
  return (
    <BasicDetailsSectionBase
      dappName={formData.dappName}
      subtitle={formData.subtitle}
      description={formData.description}
      releaseApprovalMode={formData.releaseApprovalMode}
      onInputChange={onInputChange}
      packageNameField={
        <PackageNameField
          value={formData.packageName}
          error={packageNameError}
          isChecking={isCheckingPackageName}
          showSpinner={showPackageNameSpinner}
          isValid={packageNameValid}
          onChange={onInputChange}
        />
      }
      walletField={<WalletField />}
      uploadFields={
        <>
          <Form.ImageUploadInput
            name="dappIcon"
            label="dApp Icon"
            required
            description="dApp icons must contain a background color (no transparency)."
            dimensions="512x512px"
            value={formData.dappIcon}
            onChange={(file: File | null) =>
              onSingleFileChange('dappIcon', file)
            }
            buttonType="upload"
            placeholderClassName="size-[90px]"
          />
          <Form.ImageUploadInput
            name="banner"
            label="Banner"
            required
            description="This appears at the top of the detail page, behind the dApp icon."
            dimensions="1200x600px"
            value={formData.banner}
            onChange={(file: File | null) => onSingleFileChange('banner', file)}
            buttonType="add"
            placeholderClassName="h-[90px] w-[180px]"
          />
        </>
      }
      previewUploadsField={
        <PreviewUploadsField
          dappPreviews={formData.dappPreviews}
          previewUploads={previewUploads}
        />
      }
    />
  );
}
